import { createFileRoute } from "@tanstack/solid-router"

export const Route = createFileRoute("/")({
  component: RouteComponent
})

function RouteComponent() {
  return (
    <div class="relative min-h-screen w-full bg-[#020617]">
      {/* Magenta Orb Grid Background */}
      <div
        class="absolute inset-0 z-0"
        style={{
          background: "#020617",
          "background-image": `
              linear-gradient(to right, rgba(71,85,105,0.15) 1px, transparent 1px),
              linear-gradient(to bottom, rgba(71,85,105,0.15) 1px, transparent 1px),
              radial-gradient(circle at 50% 60%, rgba(236,72,153,0.15) 0%, rgba(168,85,247,0.05) 40%, transparent 70%)
            `,
          "background-size": "40px 40px, 40px 40px, 100% 100%"
        }}
      />
      <main class="relative flex min-h-screen flex-col items-center justify-center text-white">
        <h1 class="font-semibold text-5xl">Coming Soon</h1>
      </main>
    </div>
  )
}
